import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["spinner-border", _ctx.largeSpinner ? { size: _ctx.largeSpinner } : 'spinner-border-sm']),
    role: "status"
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("span", { class: "visually-hidden" }, "Loading...", -1)
  ]))], 2))
}